import { ComponentPropsWithRef, RefObject, useEffect, useRef } from 'react';
import { isFirefox, isSafari } from 'react-device-detect';

import SortingIndicator from '@/common/Table/SortingIndicator';
import { getClasses } from '@/utils';

export type TableCellProps = {
  sorting?: {
    direction?: 'asc' | 'desc' | 'none';
    onSort?: (event: React.MouseEvent<HTMLTableCellElement>) => void;
  };
} & ComponentPropsWithRef<'td'>;

const TableCell = ({ sorting, className, children, ...props }: TableCellProps): JSX.Element => {
  const cellRef = useSafariAttrPolyfill('data-prefix', 'data-suffix', 'data-placeholder'); // Temporary polyfill for Safari & Firefox CSS attribute selector issue
  const classes = getClasses('TableCell', className);

  return (
    <td {...props} className={classes} onClick={sorting?.onSort} ref={cellRef}>
      <div className="TableCell-Content">
        {children}
        {sorting !== undefined && <SortingIndicator direction={sorting?.direction} />}
      </div>
    </td>
  );
};

const useSafariAttrPolyfill = (...props: string[]): RefObject<HTMLTableCellElement> => {
  const cellRef = useRef<HTMLTableCellElement>(null);

  useEffect((): void => {
    if (!isSafari && !isFirefox) return;
    for (var p = 0; p < props.length; p++) {
      const name = props[p];
      const key = name.replace('data-', '');
      const value = cellRef.current?.getAttribute(name);
      if (!cellRef.current || value === cellRef.current.style.getPropertyValue(`--${key}`)) return;
      if (value) {
        cellRef.current.style.setProperty(`--${key}`, `"${value}"`);
      } else {
        cellRef.current.style.removeProperty(`--${key}`);
      }
    }
  }, [props]);

  return cellRef;
};

export default TableCell;
